module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/ebsBiometry-236c968b82b68dfab7be56923157ba6b.png";